import React, { useEffect } from 'react';
import {ConnectedRouter} from 'connected-react-router';
import {Provider} from 'react-redux';
import {Switch} from 'react-router-dom';
import store, {history} from './redux/store';
import Routes from './Routes/index';
import ErrorBoundary from './util/ErrorBoundary';
import AppContextProvider from './components/contextProvider/AppContextProvider';
import AppWrapper from './components/AppWrapper';
import SelectTabContextProvider from './components/SelectTabContext/SelectTabContext2';
import CacheBuster from './CacheBuster';
import UnsavedChangesAlert from './components/DialogBox/UnsavedChangesAlert';
import ReactGA from 'react-ga4';
import getConfig from './helpers/configSettings';

const App = () => {
  useEffect(() => {
    ReactGA.initialize(getConfig('gaMeasurementID'));
  }, []);

  return (
    <CacheBuster>
      {({loading, isLatestVersion}) => {
        if (loading) {
          return null;
        }
        if (!loading && !isLatestVersion) {
          if (caches) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then(function(names) {
              for (const name of names) {
                caches.delete(name);
              }
            })
              .catch((error) => {
                console.log(error);
              });
          }

          // delete browser cache and hard reload
          window.location.reload(true);
        }
        return (
          <>
            <AppContextProvider>
              <SelectTabContextProvider>
                <Provider store={store}>
                  <ConnectedRouter history={history}>
                    <AppWrapper>
                      <Switch>
                        <ErrorBoundary>
                          <UnsavedChangesAlert />
                          <Routes />
                        </ErrorBoundary>
                      </Switch>
                    </AppWrapper>
                  </ConnectedRouter>
                </Provider>
              </SelectTabContextProvider>
            </AppContextProvider>
          </>
        );
      }}
    </CacheBuster>
  );
};
export default App;
